import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import App from './App';
import './index.css';
import { applyTheme } from './lib/theme';

applyTheme(
  (() => {
    try {
      const v = localStorage.getItem('crm.theme');
      if (v === 'dark' || v === 'light') return v;
    } catch {
      /* sin almacenamiento */
    }
    return window.matchMedia?.('(prefers-color-scheme: dark)').matches ? 'dark' : 'light';
  })(),
);

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <App />
  </StrictMode>,
);
